import aboutUsJson from "@/data/copy/about-us-page.json";
import { createCopyGetter, type Localized } from "@/lib/localize-copy";
import type { Lang } from "@/lib/types";

/**
 * Typed getter for the About page (`/sv/om-oss`, `/en/about`). All copy and
 * images live in `about-us-page.json`; team members
 * with `published: false` are placeholders shown in dev / preview only.
 */
export type AboutUsCopy = Localized<typeof aboutUsJson>;
export type AboutUsHeroCopy = AboutUsCopy["hero"];
export type AboutUsValuesCopy = AboutUsCopy["values"];
export type AboutUsPlacesCopy = AboutUsCopy["places"];
export type AboutUsTeamCopy = AboutUsCopy["team"];
export type AboutUsTeamMember = AboutUsTeamCopy["members"][number];
export type AboutUsFactsCopy = AboutUsCopy["facts"];

const getLocalizedAboutUsCopy = /*#__PURE__*/ createCopyGetter(aboutUsJson);

export function getAboutUsCopy(lang: Lang): AboutUsCopy {
  return getLocalizedAboutUsCopy(lang);
}

/** "001", "002", … — the numbered labels used across the page. */
export const padIndex = (index: number) => String(index + 1).padStart(3, "0");
